import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { isTransientNetworkError } from '../../sentry/sentry-browser-options';
import { ClientErrorMessage } from '../client/clienterror.interface';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  logClientError(error: ClientErrorMessage) {
    console.error('An error occurred:', error?.message);
    console.error('Error code:', error?.code);
    console.error('Error details:', error?.details ?? 'No details provided');

    if (isTransientNetworkError(error)) {
      return;
    }

    Sentry.captureException(toError(error), {
      tags: { error_source: 'encore_client' },
      extra: extraFromClientError(error),
    });
  }
}

export function toError(error: unknown): Error {
  if (error instanceof Error) {
    return error;
  }
  if (typeof error === 'string') {
    return new Error(error);
  }
  if (typeof error === 'object' && error !== null && 'message' in error && typeof error.message === 'string') {
    return new Error(error.message);
  }
  return new Error('Client error');
}

export function extraFromClientError(error: unknown): Record<string, unknown> {
  if (error == null || typeof error !== 'object') {
    return {};
  }

  const clientError = error as ClientErrorMessage & { status?: unknown };
  const extra: Record<string, unknown> = {
    code: clientError.code,
    details: clientError.details,
  };
  if ('status' in error) {
    extra['status'] = clientError.status;
  }
  return extra;
}
